import React, { useEffect, useMemo } from 'react';
import LeftSideMenu from '../LeftSideMenu';
import { useFormik } from 'formik';
import { Input, Form as AntdForm, notification } from 'antd';
// import * as Yup from 'yup';
import { Button } from '@ui/components';
import { createContentManager, IContentManager, updateContentManager } from '@ui/api/v2/user.api';

const { Item } = AntdForm;

interface IProps {
  manager?: IContentManager;
  onManagerUpdate: (manager: IContentManager) => void;
  onManagerCreate: (manager: IContentManager) => void;
  resetEditManager: () => void;
}

// const factorySchema = Yup.object().shape({
// });

export function ContentManagerForm({
   manager,
   onManagerUpdate,
   onManagerCreate,
   resetEditManager,
 }: IProps) {
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      middleName: '',
      login: '',
      password: '',
      idLotus: '',
    },
    async onSubmit(values, { resetForm }) {
      if (manager?.id) {
        resetEditManager();
        const response = await updateContentManager(manager.id, values);
        if (response.ok) {
          onManagerUpdate({
            ...manager,
            ...values,
          });
        }
      } else {
        const { data, error } = await createContentManager(values);
        if (data) {
          onManagerCreate(data);
        } else {
          notification.error({
            message: error.response.data.message,
          });
        }
      }
      resetForm();
    },
  });

  useEffect(() => {
    if (manager) {
      formik.setValues({
        ...formik.initialValues,
        firstName: manager.firstName || '',
        lastName: manager.lastName || '',
        middleName: manager.middleName || '',
        login: manager.login,
        idLotus: manager.idLotus,
      });
    }
  }, [manager]);

  // const cancelEditForm = useCallback(
  //   (_, { resetForm }) => {
  //     resetForm();
  //     resetEditCity();
  //   },
  //   [resetEditCity],
  // );

  const title = useMemo(() => {
    if (manager?.id) {
      return 'Редактировать менеджера';
    }
    return 'Новый менеджер';
  }, [manager]);

  return (
    <LeftSideMenu className="content__left-side" topPanel={title}>
      <form onSubmit={formik.handleSubmit} className="content__form">
        <Item label="Логин">
          <Input
            onChange={formik.handleChange}
            value={formik.values.login}
            type="text"
            name="login"
          />
        </Item>
        <Item label="Пароль">
          <Input
            onChange={formik.handleChange}
            value={formik.values.password}
            type="password"
            name="password"
          />
        </Item>
        <Item label="Фамилия">
          <Input
            onChange={formik.handleChange}
            value={formik.values.lastName}
            type="text"
            name="lastName"
          />
        </Item>
        <Item label="Имя">
          <Input
            onChange={formik.handleChange}
            value={formik.values.firstName}
            type="text"
            name="firstName"
          />
        </Item>
        <Item label="Отчество">
          <Input
            onChange={formik.handleChange}
            value={formik.values.middleName}
            type="text"
            name="middleName"
          />
        </Item>
        <Item label="ID Lotus">
          <Input
            onChange={formik.handleChange}
            value={formik.values.idLotus}
            type="text"
            name="idLotus"
          />
        </Item>
        <div className="content__buttons-wrapper">
          <Item>
            <Button type="primary" htmlType="submit">
              Сохранить
            </Button>
          </Item>
          <Item>
            <Button htmlType="reset">Отмена</Button>
          </Item>
        </div>
      </form>
    </LeftSideMenu>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContentManagers/ContentManagerForm.tsx